import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-upload-document-warning-message',
  templateUrl: './upload-document-warning-message.component.html',
  styleUrls: ['./upload-document-warning-message.component.scss']
})
export class UploadDocumentWarningMessageComponent implements OnInit {
  onedriveLink: string;

  constructor() { }

  ngOnInit() {
  }

}
@NgModule({
  declarations: [UploadDocumentWarningMessageComponent],
  entryComponents: [
    UploadDocumentWarningMessageComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    ActionLinkModule,
    LinkModule,
  ]
})
export class UploadDocumentWarningMessageModule { }
